module.exports = __webpack_public_path__ + "img/june-hur.eb771981.png";